<template>
<div>
  <header>
    <div>
      <h1>
        Cargo by GEA Logistics
      </h1>
    </div>
    <div>
      <ul class="navigation">
        <li><span>Nueva Operacion</span></li>
        <li><span>Ver Operaciones</span></li>
      </ul>
    </div>
  </header><!-- multistep form -->
  <MultiStepForm />
  <div style="clear:both;overflow: auto;"></div>
  <footer>
    <div>
      <h1>
        Cargo by GEA Logistics
      </h1>
    </div>
    <div>
      <h1>
        &copy; Copyright 2019. GEA Logistics - Todos los Derechos Reservados
      </h1>
    </div>
  </footer>
</div>
</template>
<script>
import MultiStepForm from './MultiStepForm'
export default {
  components: {
    MultiStepForm
  },
  name: 'hello',
  data () {
    return {
      msg: 'Welcome to Your Vue.js PWA'
    }
  },
  beforeMount () {
    let recaptchaScript = document.createElement('script')
    recaptchaScript.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/jquery-easing/1.3/jquery.easing.min.js')
    document.head.appendChild(recaptchaScript)
      // let script = document.createElement('script')
      // script.setAttribute('src', 'https://maps.googleapis.com/maps/api/js?key=AIzaSyCpKHUOWHl1wwbYwgTC1cx3k2QurcLxLH8&libraries=places')
      // document.head.appendChild(script)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
@import '../assets/css/estilo-form.css';

</style>



// WEBPACK FOOTER //
// src/components/Home.vue